// angular
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// interfaces
import { II18n } from '@app/shared/interfaces/i18n.interface';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';

@Component({
  selector: 'pwj-product-description',
  standalone: true,
  imports: [TranslateModule, TranslateDataPipe],
  templateUrl: './product-description.component.html',
  styleUrl: './product-description.component.scss',
})
export class ProductDescriptionComponent {
  // inputs
  productDescription = input.required<II18n>();
}
